import { useEffect, useState } from 'react'
import { Dialog, DialogContent, Stack } from '@mui/material'
import PrimaryButton from './PrimaryButton'
import { SuccessIcon } from '../svgIcons/SuccessIcon'

export default function DisclaimerDialog() {
    const [displayedDialog, setDisplayedDialog] = useState(false)
    const [didSelectRead, setDidSelectRead] = useState(false)

    useEffect(() => {
        const didSee = window.localStorage.getItem('mainnetDisclaimerShown')
        if (didSee) setDisplayedDialog(true)
    }, [])

    function onUnderstandClick() {
        if (didSelectRead) window.localStorage.setItem('mainnetDisclaimerShown', 'true')
        setDisplayedDialog(true)
    }

    if (displayedDialog) {
        return <></>
    }

    return (
        <Dialog
            className='rounded-[16px]'
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    m: 0,
                    width: '100%',
                    p: 2,
                    backgroundColor: '#151D44',
                    border: '1px solid rgba(255, 255, 255, 0.1)'
                }
            }}
            sx={{ ml: 2, mr: 2 }}
            open={!displayedDialog}>
            <span className='text-[34px] text-white'>{'Mainnet Disclaimer'}</span>

            <DialogContent id='breaking-changes-dialog-content' sx={{ p: 3, mb: 1 }}>
                <Stack spacing={1} direction={'column'}>
                    <span className='text-white text-[20px]'>
                        {`The mySwap DEX is in its alpha stage, as is the Starknet network it runs on top of.`}
                        <br></br>
                        <br></br>
                        {`This means that:`}
                        <ul className='list-disc pl-[32px]'>
                            <li>{`Things can break, and in extreme cases, this can lead to a loss of all your funds.`}</li>
                            <li>{`The contracts have not yet been audited.`}</li>
                            <li>{`The mySwap contracts can be upgraded without a timelock.`}</li>
                        </ul>
                    </span>
                </Stack>
                <div className='mt-[40px] flex items-center'>
                    <div
                        onClick={() => setDidSelectRead(!didSelectRead)}
                        className={`w-4 h-4 border border-[1px] border-[${
                            didSelectRead ? '#0AE8F9' : 'white'
                        }] rounded-[4px] cursor-pointer text-white flex justify-center items-center text-[#010620] ${didSelectRead ? 'bg-[#0AE8F9]' : 'bg-[transparent]'}`}>
                        {didSelectRead ? <SuccessIcon className='w-3 h-3' /> : null}
                    </div>
                    <span className='text-white ml-2 text-[14px]'>Don’t show this message again</span>
                </div>
            </DialogContent>

            <PrimaryButton onClick={onUnderstandClick}>
                <span>I UNDERSTAND</span>
            </PrimaryButton>
        </Dialog>
    )
}
